import { AbstractCommand } from 'src/models/command';

class SaveTheMailTemplateCommand extends AbstractCommand {
	readonly name = 'IFS_Mail_Command_Command_SaveTheMailTemplateCommand';

	public constructor(
		templateName: string,
		templateId: string,
		senderAccountId: number,
		managedSignatureId: number,
		subject: string,
		content: string,
		receiversTo: Array<string>,
		receiversCC: Array<string>,
		receiversBCC: Array<string>,
		attachmentIds: Array<string>,
		originalAttachmentIds: Array<string>,
		replyOrForwardMailAggregateId: string,
		replyOrForwardType: string
	) {
		super();
		this.parameters = {
			attachmentIds: attachmentIds,
			content: content,
			managedSignatureId: managedSignatureId,
			originalAttachmentIds: originalAttachmentIds,
			receiversBCC: receiversBCC,
			receiversCC: receiversCC,
			receiversTo: receiversTo,
			replyOrForwardMailAggregateId: replyOrForwardMailAggregateId,
			replyOrForwardType: replyOrForwardType,
			senderAccountId: senderAccountId,
			subject: subject,
			templateId: templateId,
			templateName: templateName,
		};
	}
}

export { SaveTheMailTemplateCommand };
